import PropType from 'prop-types';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { TIME_TYPE, UNIT_TYPE } from 'util/config/constant';
import { TRANSLATION_NAMESPACES } from 'util/translation/constant';
import { translateHour } from 'util/translation/wordForm';
import { CleanedSquareValue } from 'components/UI/CleanedSquareValue';

const MachineTotalCleaning = ({ unit, total, totalByTime, time }) => {
  const { t } = useTranslation(TRANSLATION_NAMESPACES.MACHINE_DETAILS);

  const renderTotal = useCallback(() => {
    const { cleanedSquareMeter, hours } = total || {};
    if (unit === UNIT_TYPE.hours) {
      return translateHour(t, hours);
    }

    return <CleanedSquareValue cleanedSquareMeter={cleanedSquareMeter || 0} />;
  }, [total, unit, t]);

  const renderTotalByTime = useCallback(() => {
    const { cleanedSquareMeter, hours } = totalByTime || {};
    if (unit === UNIT_TYPE.hours) {
      return translateHour(t, hours);
    }

    return <CleanedSquareValue cleanedSquareMeter={cleanedSquareMeter || 0} />;
  }, [totalByTime, unit, t]);

  const renderTitleUnit = useCallback(() => {
    if (unit === UNIT_TYPE.hours) {
      return t('cleaningAreaPanel.operatingHoursText');
    }

    return t('cleaningAreaPanel.cleanedAreaText');
  }, [t, unit]);

  const renderTitleTime = useCallback(() => {
    switch (time) {
      case TIME_TYPE.Past6Months:
        return t('cleaningAreaPanel.sixMonths');
      case TIME_TYPE.Month:
        return t('cleaningAreaPanel.thisMonth');
      case TIME_TYPE.Week:
        return t('cleaningAreaPanel.thisWeek');
      case TIME_TYPE.Year:
      default:
        return t('cleaningAreaPanel.thisYear');
    }
  }, [t, time]);

  return (
    <div className="machine-total-cleaning">
      <div className="title">
        {renderTitleTime()} {renderTitleUnit()}
      </div>
      <div className="number">{renderTotalByTime()}</div>
      <hr />
      <div className="title-total">
        {t('cleaningAreaPanel.total')} {renderTitleUnit()}
      </div>
      <div className="number-total">{renderTotal()}</div>
    </div>
  );
};

export default MachineTotalCleaning;

MachineTotalCleaning.propTypes = {
  unit: PropType.string.isRequired,
  time: PropType.string.isRequired,
  total: PropType.shape().isRequired,
  totalByTime: PropType.shape().isRequired
};
